const SVGChevronRight = '<svg class="Form__chevronRight" viewBox="0 0 256 256"><polygon points="79.093,0 48.907,30.187 146.72,128 48.907,225.813 79.093,256 207.093,128"/></svg>';

export default SVGChevronRight;
